/**
 * @fileoverview POST handler for the "/engagement/export_logs/:log_id/:app_group_id/cancel" endpoint
 */
import fetch from "@lib/fetch";

import {
  reactQueryMutationAdapter,
  createMutationFetcherFunctionWithShadowError,
} from "../reactQueryFetcherAdapters";
import { engagementExportLogsCancelCacheKeys } from "./constants";
import type {
  PostEngagementExportLogsLogIdAppGroupIdCancelProps,
  ExportLogsCancelResult,
  ExportLogsCancelErrors,
} from "./types";

export const postExportLogsCancel = reactQueryMutationAdapter(
  engagementExportLogsCancelCacheKeys,
  createMutationFetcherFunctionWithShadowError<ExportLogsCancelErrors>()(
    (props: PostEngagementExportLogsLogIdAppGroupIdCancelProps): Promise<ExportLogsCancelResult> => {
      return fetch(`/engagement/export_logs/${props.logId}/${props.appGroupId}/cancel`, "POST", props, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
